import React, { Component } from "react";
import { Carousel } from "react-bootstrap";
//images
import participantAvtar from "../../../../images/participantAvtar.jpg";
import winnerCrown from "../../../../images/icon/winner-crown.png";
import orgIc from "../../../../images/icon/org-ic.png";
import star from "../../../../images/score/star.png";
import { ellipsis, scoreCardGameURL } from "../../../../utils/common.utils";
import SponsorCards from "./SponsorCards";
import CardHeader from "./CardHeader";
import DuelForfeitCase from "./DuelForfeitCase";

export default class FreefireCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      matchDetails: props.matchDetails,
      tournamentDetails: props.tournamentDetails,
    };
    this.gameUrl = scoreCardGameURL(props.tournamentDetails?.gameDetails?.name);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      matchDetails: nextProps.matchDetails,
      tournamentDetails: nextProps.tournamentDetails,
    });
  }

  // Reusable component for displaying team/player in duel
  renderPlayerDisplay = (participant, isWinner, name, isTeamMVP, isMatchMVP) => (
    <div className="">
      {isWinner && <span className="winner-shadow"></span>}
      <span className="d-flex flex-column align-items-center">
        {isWinner && (
          <img src={winnerCrown} className="mb-1" alt="" style={{ height: "15px", zIndex: "1" }} />
        )}
        <img
          src={participant?.logo?.url || participant?.profilePicture?.url}
          className="rounded-circle"
          alt=""
          style={{ height: "50px", width: "50px", zIndex: "1" }}
        />
      </span>
      <h5 className="text-white fw-bold fs-10 mt-2 text-center">{name}</h5>
      {isMatchMVP && <p className="text-warning fs-8 fw-bold text-center my-0">MVP</p>}
    </div>
  );

  // Reusable KDA display table
  renderKDATable = (title, stats) => (
    <table className="table table-borderless mt-2">
      <thead>
        <tr className="scorecard_header">
          <th scope="col" className="team_header fs-8 fw-600 text-white">
            {title}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className="scorecard_body">
          <td className="fs-8 fw-600 text-white team_body">{stats}</td>
        </tr>
      </tbody>
    </table>
  );

  // Reusable component for MVP display
  renderMVPDisplay = (mvpData, title) => (
    <div className="text-center">
      <div className="">
        <img
          src={mvpData?.participantDetails?.profilePicture?.url || participantAvtar}
          className="btn-size-25 rounded-circle mb-2"
          alt=""
        />
      </div>
      <div className="">
        <h1 className="fs-10 fw-600 text-white mb-0">
          {mvpData?.inGameName || mvpData?.participantDetails?.inGameName}
        </h1>
        <p className="fs-8 fw-600 text-warning mb-0">{title}</p>
        <p className="fs-8 fw-600 text-white mb-0">{`${mvpData?.kills}-${mvpData?.deaths}-${mvpData?.assists}`}</p>
      </div>
    </div>
  );

  // Reusable component for player scores table
  renderPlayerScoresTable = (teamData, teamName) => (
    <table className="table table-borderless">
      <thead>
        <tr className="scorecard_header">
          <th scope="col" className="team_header fs-8 fw-600 text-white">
            TEAM
          </th>
          <th scope="col" className="name_header fs-8 fw-600 text-white">
            NAME
          </th>
          <th scope="col" className="score_header fs-8 fw-600 text-white">
            KDA
          </th>
        </tr>
      </thead>
      <tbody>
        {teamData?.individualScore?.map((player, i) => {
          const isTeamMVP = teamData?.teamMVP?._id === player.participantDetails?._id;
          const isMatchMVP = teamData?.matchMVP?._id === player.participantDetails?._id;
          return (
            <tr className="scorecard_body" key={i}>
              <td className="fs-8 fw-600 text-white team_body">{teamName}</td>
              <td className="fs-8 fw-600 text-white">
                {player?.participantDetails?.inGameName}
                {isTeamMVP && <span className="fs-8 fw-bold text-warning ms-1">MVP</span>}
                {isMatchMVP && <span className="fs-8 fw-bold ms-2 text-white">MVP</span>}
              </td>
              <td className="fs-8 fw-600 text-white team_score">
                {`${player.kills}-${player.deaths}-${player.assists}`}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  // Reusable component for FFA card
  renderFFACard = (participant, rank, kills, score, pointSystem, pointsPerKill, index) => (
    <div className="col-6 px-1" key={index}>
      <div className="freefire_card d-flex p-1 mb-1">
        <div className="me-1">
          <p className="fs-12 fw-700 text-warning">#{rank}</p>
        </div>
        <div className="d-flex flex-grow-1">
          <img
            src={participant?.logo?.url || participant?.profilePicture?.url || orgIc}
            className="rounded-circle btn-size-20"
            alt=""
          />
          <div className="ms-2">
            <h1 className="fs-12 fw-600 text-white mb-0">
              {participant?.name ? ellipsis(participant?.name, 9) : participant?.inGameName}
            </h1>
            <p className="fs-12 fw-600 text-white mb-0">Kills: {kills}</p>
          </div>
        </div>
        <div className="">
          <p className="fs-12 fw-600 text-white mb-0">
            <img src={star} alt="" />
            {score}
          </p>
          <p className="fs-12 fw-600 text-white mb-0">
            R-{pointSystem ? pointSystem[index] : score - kills} + K-{kills * (pointsPerKill || 1)}
          </p>
        </div>
      </div>
    </div>
  );

  // Teams players listing for Team FFA
  renderTeamPlayers = individualScores => (
    <div className="d-flex flex-column flex-grow-1">
      {individualScores.map((player, k) => (
        <div className="d-flex justify-content-between" key={k}>
          <p className="fs-12 fw-600 text-white mb-0">{player.participantDetails?.inGameName}</p>
          <p className="fs-12 fw-600 text-white mb-0">{player.kills}</p>
        </div>
      ))}
    </div>
  );

  // Team Duel component
  getTeamDuel = () => {
    const { matchDetails, tournamentDetails } = this.state;

    // For multiple games
    if (matchDetails?.results.length > 1) {
      return (
        <Carousel>
          {matchDetails.results.map((el, i) => {
            // Check for forfeit case
            let p1forfeit = el[0].forfeit ? true : false;
            let p2forfeit = el[1].forfeit ? true : false;

            if (p1forfeit || p2forfeit) {
              return (
                <Carousel.Item key={i}>
                  <DuelForfeitCase game={el} tournamentDetails={tournamentDetails} />
                </Carousel.Item>
              );
            }

            // Find MVPs
            const teamMVP = [...el[0].individualScore, ...el[1].individualScore].find(
              val => val.participantDetails?._id === el[0].teamMVP?._id
            );
            const matchMVP = [...el[0].individualScore, ...el[1].individualScore].find(
              val => val.participantDetails?._id === el[0].matchMVP?._id
            );

            return (
              <Carousel.Item key={i}>
                <div className="col-12 col-md-10 col-lg-8 mx-auto">
                  <div className="scoreboard-bg-image mt-2 p-3">
                    <CardHeader tournamentDetails={tournamentDetails} />
                    <p className="fs-10 fw-bold text-end">
                      Game {i + 1} of {matchDetails.results.length}
                    </p>

                    {/* Teams display */}
                    <div className="text-center d-flex justify-content-evenly align-items-end">
                      {this.renderPlayerDisplay(
                        matchDetails.participants[0],
                        el[0].isWinner,
                        matchDetails.participants[0].name
                      )}

                      <div className="align-self-center">
                        <p className="text-white fw-700 fs-14 mb-1">{`${el[0].score}-${el[1].score}`}</p>
                      </div>

                      {this.renderPlayerDisplay(
                        matchDetails.participants[1],
                        el[1].isWinner,
                        matchDetails.participants[1].name
                      )}
                    </div>

                    {/* Team MVP and scores display */}
                    <div className="row mt-2">
                      <div className="col-3 p-0">
                        {this.renderMVPDisplay(el[0].teamMVP, "Team MVP")}
                      </div>
                      <div className="col-9 p-0">
                        {this.renderPlayerScoresTable(el[0], el[0].teamDetails?.name)}
                      </div>
                    </div>

                    {/* Match MVP and scores display */}
                    <div className="row">
                      <div className="col-3 p-0">
                        {this.renderMVPDisplay(el[0].matchMVP, "Match MVP")}
                      </div>
                      <div className="col-9 p-0">
                        {this.renderPlayerScoresTable(el[1], el[1].teamDetails?.name)}
                      </div>
                    </div>

                    <SponsorCards tournamentDetails={tournamentDetails} />
                  </div>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      );
    }

    // For single game
    else {
      const teamMVP = [
        ...matchDetails.results[0][0].individualScore,
        ...matchDetails.results[0][1].individualScore,
      ].find(val => val.participantDetails?._id === matchDetails.results[0][0].teamMVP?._id);
      const matchMVP = [
        ...matchDetails.results[0][0].individualScore,
        ...matchDetails.results[0][1].individualScore,
      ].find(val => val.participantDetails?._id === matchDetails.results[0][0].matchMVP?._id);

      return (
        <div className="col-12 col-md-10 col-lg-8 mx-auto">
          <div className="scoreboard-bg-image mt-2 p-3">
            <CardHeader tournamentDetails={tournamentDetails} />

            {/* Teams display */}
            <div className="text-center d-flex justify-content-evenly align-items-end">
              {this.renderPlayerDisplay(
                matchDetails.participants[0],
                matchDetails.results[0][0].isWinner,
                matchDetails.participants[0].name
              )}

              <div className="align-self-center">
                <p className="text-white fw-700 fs-14 mb-1">
                  {`${matchDetails.results[0][0].kills}-${matchDetails.results[0][1].kills}`}
                </p>
              </div>

              {this.renderPlayerDisplay(
                matchDetails.participants[1],
                matchDetails.results[0][1].isWinner,
                matchDetails.participants[1].name
              )}
            </div>

            {/* Team MVP and scores display */}
            <div className="row mt-2">
              <div className="col-3">{this.renderMVPDisplay(teamMVP, "Team MVP")}</div>
              <div className="col-9">
                {this.renderPlayerScoresTable(
                  matchDetails.results[0][0],
                  matchDetails.results[0][0].teamDetails?.name
                )}
              </div>
            </div>

            {/* Match MVP and scores display */}
            <div className="row">
              <div className="col-3">{this.renderMVPDisplay(matchMVP, "Match MVP")}</div>
              <div className="col-9">
                {this.renderPlayerScoresTable(
                  matchDetails.results[0][1],
                  matchDetails.results[0][1].teamDetails?.name
                )}
              </div>
            </div>

            <SponsorCards tournamentDetails={tournamentDetails} />
          </div>
        </div>
      );
    }
  };

  // Solo Duel results component
  getSoloDuelFinalResults = () => {
    const { matchDetails, tournamentDetails } = this.state;
    return (
      <div className="col-12 col-md-10 col-lg-8 mx-auto">
        <div className="scoreboard-bg-image mt-2 p-3">
          <CardHeader tournamentDetails={tournamentDetails} />
          <div className="d-flex justify-content-evenly align-items-end">
            {/* Player 1 */}
            <div className="">
              {this.renderPlayerDisplay(
                matchDetails.participants[0],
                matchDetails.finalResult[0].isWinner,
                matchDetails.participants[0].inGameName
              )}
              {this.renderKDATable(
                "KD",
                `${matchDetails.finalResult[0].kills} - ${matchDetails.finalResult[0].deaths}`
              )}
            </div>

            {/* Score */}
            <div className="">
              <p className="text-white fw-700 fs-14 mb-1">
                {`${matchDetails.finalResult[0].score}-${matchDetails.finalResult[1].score}`}
              </p>
            </div>

            {/* Player 2 */}
            <div className="">
              {this.renderPlayerDisplay(
                matchDetails.participants[1],
                matchDetails.finalResult[1].isWinner,
                matchDetails.participants[1].inGameName
              )}
              {this.renderKDATable(
                "KD",
                `${matchDetails.finalResult[1].kills} - ${matchDetails.finalResult[1].deaths}`
              )}
            </div>
          </div>
          <SponsorCards tournamentDetails={tournamentDetails} />
        </div>
      </div>
    );
  };

  // Solo Duel component
  getSoloDuel = () => {
    const { matchDetails, tournamentDetails } = this.state;

    // For multiple games
    if (matchDetails?.results?.length > 1) {
      return (
        <Carousel slide={false}>
          <Carousel.Item>{this.getSoloDuelFinalResults()}</Carousel.Item>

          {matchDetails.results.map((el, i) => {
            // Check for forfeit case
            let p1forfeit = el[0].forfeit ? true : false;
            let p2forfeit = el[1].forfeit ? true : false;

            if (p1forfeit || p2forfeit) {
              return (
                <Carousel.Item key={i}>
                  <DuelForfeitCase game={el} tournamentDetails={tournamentDetails} />
                </Carousel.Item>
              );
            }

            return (
              <Carousel.Item key={i}>
                <div className="col-12 col-md-10 col-lg-8 mx-auto">
                  <div className="scoreboard-bg-image mt-2 p-3">
                    <CardHeader tournamentDetails={tournamentDetails} />
                    <div className="d-flex justify-content-evenly align-items-end">
                      {/* Player 1 */}
                      <div className="">
                        {this.renderPlayerDisplay(
                          el[0].participantDetails,
                          el[0].isWinner,
                          matchDetails.participants[0].inGameName,
                          false,
                          el[0].participantDetails._id === el[0].matchMVP._id
                        )}
                        {this.renderKDATable("KD", `${el[0].kills} - ${el[0].deaths}`)}
                      </div>

                      {/* Score */}
                      <div className="">
                        <p className="text-white fw-700 fs-14 mb-1">{`${el[0].kills}-${el[1].kills}`}</p>
                      </div>

                      {/* Player 2 */}
                      <div className="">
                        {this.renderPlayerDisplay(
                          el[1].participantDetails,
                          el[1].isWinner,
                          matchDetails.participants[1].inGameName,
                          false,
                          el[1].participantDetails._id === el[1].matchMVP._id
                        )}
                        {this.renderKDATable("KD", `${el[1].kills} - ${el[1].deaths}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      );
    }

    // For single game
    else {
      return this.getSoloDuelFinalResults();
    }
  };

  // Team FFA component
  getTeamFFA = () => {
    const { matchDetails, tournamentDetails } = this.state;

    // Render FFA game results
    const renderGameResults = gameData => {
      let arr = Object.values(gameData).filter(k => k.teamDetails);
      let sortedArray = arr.sort((a, b) => parseInt(b.score) - parseInt(a.score));

      return (
        <div className="row">
          {sortedArray.map((res, j) => (
            <div className="col-12 col-md-12 col-lg-6 p-1" key={j}>
              <div className="freefire_card d-flex p-3">
                <div className="me-1">
                  <p className="fs-12 fw-700 text-warning">#{res.rank}</p>
                </div>
                <div className="d-flex flex-grow-1">
                  <img
                    src={res.teamDetails?.logo?.url}
                    className="rounded-circle btn-size-20"
                    alt=""
                  />
                  <div className="ms-2">
                    <h1 className="fs-12 fw-600 text-white mb-0">
                      {ellipsis(res.teamDetails?.name, 9)}
                    </h1>
                    <p className="fs-12 fw-600 text-white mb-0">Kills: {res?.kills}</p>
                    <p className="fs-12 fw-600 text-white mb-0">
                      <img src={star} alt="" />
                      {res?.score}
                    </p>
                    <p className="fs-12 fw-600 text-white mb-0">
                      R-{tournamentDetails.gameDetails.pointSystem[j + 1]} + K-
                      {res.kills * tournamentDetails?.gameDetails?.pointsPerKill}
                    </p>
                  </div>
                </div>
                {this.renderTeamPlayers(res.individualScore)}
              </div>
            </div>
          ))}
        </div>
      );
    };

    // For multiple games
    if (matchDetails?.results.length > 1) {
      return (
        <Carousel>
          {matchDetails.results.map((el, i) => (
            <Carousel.Item key={i}>
              <div className="col-12 col-md-10 col-lg-8 mx-auto">
                <div className="scoreboard-bg-image mt-2 p-3">
                  <CardHeader tournamentDetails={tournamentDetails} />
                  <p className="fs-10 fw-bold text-end">
                    Game {i + 1} of {matchDetails.results.length}
                  </p>
                  {renderGameResults(el)}
                  <SponsorCards tournamentDetails={tournamentDetails} />
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      );
    }

    // For single game
    else {
      return (
        <div className="col-12 col-md-10 col-lg-8 mx-auto">
          <div className="mt-2 p-3">
            <CardHeader tournamentDetails={tournamentDetails} />
            {renderGameResults(matchDetails.results[0])}
            <SponsorCards tournamentDetails={tournamentDetails} />
          </div>
        </div>
      );
    }
  };

  // Solo FFA component
  getSoloFFA = () => {
    const { matchDetails, tournamentDetails } = this.state;

    // Render solo FFA results
    const renderSoloFFAResults = (gameData, gameIndex) => {
      let arr = Object.values(gameData).filter(k => k.participantDetails);
      let sortedArray = arr.sort((a, b) => parseInt(a.rank) - parseInt(b.rank));

      return (
        <div className="row mt-3">
          {sortedArray.map((res, i) =>
            this.renderFFACard(
              res.participantDetails,
              res.rank || i + 1,
              res.kills,
              res.score,
              tournamentDetails.gameDetails.pointSystem,
              tournamentDetails?.gameDetails?.pointsPerKill,
              i
            )
          )}
        </div>
      );
    };

    // For multiple games
    if (matchDetails?.results.length > 1) {
      return (
        <Carousel>
          {matchDetails.results.map((game, i) => (
            <Carousel.Item key={i}>
              <div className="col-12 col-md-10 col-lg-8 mx-auto">
                <div className="scoreboard-bg-image mt-2 p-3">
                  <CardHeader tournamentDetails={tournamentDetails} />
                  <p className="fs-8 fw-bold text-end">
                    Game {i + 1} of {matchDetails.results.length}
                  </p>
                  {renderSoloFFAResults(game, i)}
                  <SponsorCards tournamentDetails={tournamentDetails} />
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      );
    }

    // For single game
    else {
      return (
        <div className="col-12 col-md-10 col-lg-8 mx-auto">
          <div className="mt-2 p-3">
            <CardHeader tournamentDetails={tournamentDetails} />
            {renderSoloFFAResults(matchDetails.results[0])}
            <SponsorCards tournamentDetails={tournamentDetails} />
          </div>
        </div>
      );
    }
  };

  // Choose the appropriate card based on tournament type
  getCard = () => {
    const { tournamentDetails } = this.state;

    switch (true) {
      case tournamentDetails?.participantType === "SINGLE" &&
        tournamentDetails?.competitionType === "DUEL":
        return this.getSoloDuel();
      case tournamentDetails?.participantType === "SINGLE" &&
        tournamentDetails?.competitionType === "FFA":
        return this.getSoloFFA();
      case tournamentDetails?.participantType === "TEAM" &&
        tournamentDetails?.competitionType === "FFA":
        return this.getTeamFFA();
      case tournamentDetails?.participantType === "TEAM" &&
        tournamentDetails?.competitionType === "DUEL":
        return this.getTeamDuel();
      default:
        return null;
    }
  };

  render() {
    return <div className="p-0">{this.getCard()}</div>;
  }
}
